import {
  GET_COURSE_KNOWLEDGES,
  GET_COURSE_KNOWLEDGES_SUCCESS,
  GET_COURSE_KNOWLEDGES_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  courseKnowledges: [],
}

const CourseKnowledgesList = (state = initialState, action) => {
  switch (action.type) {
    case GET_COURSE_KNOWLEDGES:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_COURSE_KNOWLEDGES_SUCCESS:
      state = {
        ...state,
        courseKnowledges: action.payload.courseKnowledges,
        loading: false,
        done: true,
      }
      break
    case GET_COURSE_KNOWLEDGES_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default CourseKnowledgesList
